import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {AutoCompleteCompleteEvent} from "primeng/autocomplete";

@Component({
    selector: 'app-text-chip-input',
    templateUrl: './text-chip-input.component.html',
    standalone: false
})
export class TextChipInputComponent {

  @Input() formGroup : FormGroup
  @Input() id : string
  @Input() placeholder : string
  @Input() label : string
  @Input() maxChips : number
  @Input() formError : string

  /** Sem sugestões remotas — apenas entrada livre com separador (substitui o antigo p-chips). */
  chipSuggestions: string[] = [];

  onComplete(_event: AutoCompleteCompleteEvent): void {
    this.chipSuggestions = [];
  }

  onChipAdd(): void {
    if (!this.maxChips || !this.formGroup?.get(this.id)) {
      return;
    }
    const ctrl = this.formGroup.get(this.id);
    const val = ctrl?.value as string[] | undefined;
    if (Array.isArray(val) && val.length > this.maxChips) {
      ctrl?.setValue(val.slice(0, this.maxChips));
    }
  }

}
